module.exports = __webpack_public_path__ + "img/2.b16bf1d4.jpg";